import { api } from './api';

export const tagApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTags: builder.query({
      query: () => ({
        url: 'getTags',
      }),
      providesTags: ['Tags'],
    }),

    // Non-deleted products carrying the tag: [{ id, name, inactivated }].
    getTagProducts: builder.query({
      query: ({ id }) => ({
        url: 'getTagProducts',
        params: { id },
      }),
      providesTags: ['Tags'],
    }),

    // { name } creates (or returns the existing match); { id, name } renames.
    // Renaming onto an existing tag fails with 409 { mergeInto, affectedCount }
    // until retried with confirmMerge: true.
    saveTag: builder.mutation({
      query: ({ id, name, confirmMerge }) => ({
        url: 'saveTag',
        method: 'POST',
        body: { id, name, confirmMerge },
      }),
      invalidatesTags: ['Tags'],
    }),

    deleteTag: builder.mutation({
      query: ({ id }) => ({
        url: 'deleteTag',
        method: 'POST',
        body: { id },
      }),
      invalidatesTags: ['Tags'],
    }),
  }),
});

export const {
  useGetTagsQuery,
  useGetTagProductsQuery,
  useSaveTagMutation,
  useDeleteTagMutation,
} = tagApi;
